/*
* @port:[
    {
        ip: '127.0.0.1', //选择的ip
        portArray: [-1, ..., -1], //ip对应的端口
    },
    {
        ip: '192.168.10.1',
        portArray: [-1, ..., -1]
    }
  ]

  @allref: ['ref1', 'ref2'] //所有表单的ref
*/
export default{
    innerport: [],
    outerport: [],
    allref: [],
    portmapVerified: [], //端口映射已验证通过的集合
    rangeVerified: [], //端口范围验证通过的集合
    socketInfo: null, //存储websocket推送的消息

    menus: [], //登录用户的菜单权限
    listOperations: [], //列表页操作的集合, 不包含“新增(addItem)”
    currentMenuOperations: [], //当前菜单的所有操作
    currentMenu: null, //当前路由下的菜单对象
    
    // nps相关-start
    fastMenus: [
    ],
    isBigMenu: false,
    isHideMenu: false,
    menuHeight: 0,
    bigWidth: 100,
    homeScrollTop: 0, // 主页滚动条位置
    isOverFastMenusLength: false,
    tableHeight: undefined,
    // nps相关-end
}